import { format } from 'date-fns'
import { formatNumber } from 'devextreme/localization'
import { NumberFormat } from '../constants/index.jsx'

export const receiptPrintTemplate = (encoder, t, company, document) => {
  const linesData = document.lines.map((line) => {
    return [
      parseFloat(line.quantity).toString(),
      line.description, formatNumber(parseFloat(line.price), NumberFormat.display),
      formatNumber(parseFloat(line.vat_amount), NumberFormat.display),
      formatNumber(parseFloat(line.total), NumberFormat.display)
    ]
  })

  encoder
    .initialize()
    .codepage('auto')
    .newline()
    .size(2)
    .align('center')
    .bold(true)
    .line(company.name)
    .bold(false)
    .newline()
    .size(1)
    .line(company.address)
    .line(`${company.post_code.code}, ${company.city.name[company.language_code]}`)
    .line(company.vat_registration_number)
    .newline()
    .line(company.phone)
    .line(company.email)
    .line(company.website)
    .newline()
    .align('left')
    .font('B')
    .line(format(new Date(document.created_at), 'yyyy-MM-dd HH:mm:ss'))
    .line(`${t('labels.no')}: ${document.no}`)
    .newline()
    .font('B')
    .table(
      [
        { width: Math.round(encoder.columns * 0.15), align: 'left' },
        { width: Math.round(encoder.columns * 0.24), align: 'left' },
        { width: Math.round(encoder.columns * 0.2), align: 'right' },
        { width: Math.round(encoder.columns * 0.2), align: 'right' },
        { width: Math.round(encoder.columns * 0.21), align: 'right' }
      ],
      [
        [
          (encoder) => encoder.bold(true).text(t('labels.quantity_short')).bold(false),
          (encoder) => encoder.bold(true).text(t('labels.product')).bold(false),
          (encoder) => encoder.bold(true).text(t('labels.price')).bold(false),
          (encoder) => encoder.bold(true).text(t('labels.vat')).bold(false),
          (encoder) => encoder.bold(true).text(t('labels.total')).bold(false)
        ],
        [
          (encoder) => encoder.rule(),
          (encoder) => encoder.rule(),
          (encoder) => encoder.rule(),
          (encoder) => encoder.rule(),
          (encoder) => encoder.rule()
        ],
        ...linesData
      ]
    )
    .font('A')
    .rule()
    .bold(true)
    .table(
      [
        { width: Math.round(encoder.columns * 0.5), align: 'left' },
        { width: Math.round(encoder.columns * 0.5), align: 'right' }
      ],
      [
        [t('labels.base'), formatNumber(parseFloat(document.base_amount), NumberFormat.display)],
        [t('labels.discount'), formatNumber(parseFloat(document.discount_amount), NumberFormat.display)],
        [t('labels.vat'), formatNumber(parseFloat(document.vat_amount), NumberFormat.display)],
        [t('labels.total'), formatNumber(parseFloat(document.total), NumberFormat.display)]
      ]
    )
    .bold(false)

  if (company.company_greeting[company.language_code]) {
    encoder.newline(2)
      .align('center')
      .line(company.company_greeting[company.language_code])
  }

  return encoder
}
